import { theme } from 'antd';
import { LogoAccessNoBackground, LogoLockerNoBackground } from 'assets/images/svg/Logos';
import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { Flex, Typography } from 'zui/Antd';

const { Text } = Typography;

const Logo = ({ product }) => {
	const {
		token: { colorPrimary, fontWeightStrong }
	} = theme.useToken();

	const { collapsed } = useSelector((state) => state.App);

	return (
		<Fragment>
			{product !== 'lockers' ? (
				<Flex align='center' gap={6}>
					<LogoAccessNoBackground width={20} height={20} />
					{!collapsed && <Text style={{ color: colorPrimary, fontWeight: fontWeightStrong }}>Access</Text>}
				</Flex>
			) : (
				<Flex align='center' gap={6}>
					<LogoLockerNoBackground />
					{!collapsed && <Text style={{ color: colorPrimary, fontWeight: fontWeightStrong }}>Lockers</Text>}
				</Flex>
			)}
		</Fragment>
	);
};

export default Logo;
